import React from "react";
import { Link } from "gatsby";

export default function Cta({ children, href, className, target }: { children: React.ReactNode, href:string, className?:string, target?:React.HTMLAttributeAnchorTarget }) {
    return <Link to={href} className={className ?? ""} target={target}>
        {children}
    </Link>
}